import { Component, Input } from '@angular/core';
import { MetadataExt } from 'src/app/common/models/metadati/metadata';

@Component({
  selector: '[metadata-view]',
  templateUrl: './metadata-view.component.html',
  styleUrls: ['./metadata-view.component.css']
})
export class MetadataViewComponent {

  @Input() metadata: MetadataExt[];

  constructor(){}

  removeAssociation(joinId: String){
    //todo remove association
    console.log("remove : " + joinId)
  }

}
